var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { memo } from 'react';
import { TableBodyCell, TableCellEmpty } from '@pocketlaw/tetris';
import { IdChip } from 'app/domains/common-ui/IdChip';
function EntityIdCellComponent(props) {
    const { value, type } = props, rest = __rest(props, ["value", "type"]);
    if (!value) {
        return (<TableBodyCell {...rest}>
        <TableCellEmpty />
      </TableBodyCell>);
    }
    return (<TableBodyCell {...rest}>
      <IdChip size="small" id={value} type={type}/>
    </TableBodyCell>);
}
export const EntityIdCell = memo(EntityIdCellComponent);
